import { PAYMENT_INITIAL_FAILURE, PAYMENT_INITIAL_REQUEST, PAYMENT_INITIAL_SUCCESS } from '../ActionTypes'
import { ApiConfig } from '../../config/ApiConfig'
// import axios from './../../config/axios';
import { postRequest } from '../../services';
import axios from 'axios';


// const config = {
//     headers: { 
//         'Content-Type': 'application/json',
//         Accept: 'application/json',
//         // 'X-ClientSecret':ApiConfig.clientSecret
//     }
// }

// Calls the API to get Payment Initials
// export const getPaymentInitials = (requestData) => {
//     return dispatch => {
//         dispatch({ type: PAYMENT_INITIAL_REQUEST });
//         let endpoint = `${ApiConfig.getPaymentSessionUrl}`;
//         return axios.post(endpoint, requestData, config)
//             .then(res => {
//                 return dispatch({ type: PAYMENT_INITIAL_SUCCESS, data: res.data.data, isFetching: false });
//             })
//             .catch(error => {
//                 let errorMsg = 'Sorry! something went wrong, please try again.';
//                 const errorsList = error.response.data.errors;
//                 if (errorsList.message !== 'Validation Errors') {
//                     errorMsg = errorsList.message;
//                 } else {
//                     for (const key in errorsList.detail) {
//                         if (errorsList.detail.hasOwnProperty(key)) {
//                             if (typeof errorsList.detail === 'undefined') {
//                                 errorMsg = errorsList.message;
//                             } else {
//                                 errorMsg = errorsList.detail[key];
//                             }
//                         }
//                     }
//                 }
//                 return dispatch({ type: PAYMENT_INITIAL_FAILURE, hasError:true, errorMessage:errorMsg, isFetching: false });
//             })
//     }
// }


// Calls the API to get Payment Initials
export const getPaymentInitials = (data) => (dispatch) => {
	dispatch({ type: PAYMENT_INITIAL_REQUEST })
	return postRequest(ApiConfig.getPaymentSessionUrl, data).then((res) => {
		dispatch({ type: PAYMENT_INITIAL_SUCCESS, data: res })
		return res
	}).catch((err) => {
		dispatch({ type: PAYMENT_INITIAL_FAILURE })
        return err ? err?.errors?.message : 'There is some problem with Payment Gateway'
	})
}